import React from "react";
import Chip from "@mui/material/Chip";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";
import AutorenewRoundedIcon from "@mui/icons-material/AutorenewRounded";
import ScheduleRoundedIcon from "@mui/icons-material/ScheduleRounded";
import { AgentStatus, DraftStatus, RunStatus } from "../types";

type ChipColor = "success" | "error" | "warning" | "info" | "default";

const RUN_MAP: Record<
  RunStatus,
  { label: string; color: ChipColor; icon: React.ReactElement }
> = {
  SUCCESS: {
    label: "Success",
    color: "success",
    icon: <CheckCircleRoundedIcon />,
  },
  FAILED: { label: "Failed", color: "error", icon: <ErrorRoundedIcon /> },
  RUNNING: { label: "Running", color: "info", icon: <AutorenewRoundedIcon /> },
  QUEUED: { label: "Queued", color: "default", icon: <ScheduleRoundedIcon /> },
};

const AGENT_MAP: Record<AgentStatus, { label: string; color: ChipColor }> = {
  DEPLOYED: { label: "Agent deployed", color: "success" },
  GENERATING: { label: "Generating", color: "info" },
  VALIDATION_FAILED: { label: "Validation failed", color: "error" },
  NOT_DEPLOYED: { label: "Not deployed", color: "default" },
};

const DRAFT_MAP: Record<DraftStatus, { label: string; color: ChipColor }> = {
  PENDING_REVIEW: { label: "Pending review", color: "warning" },
  CHANGES_REQUESTED: { label: "Changes requested", color: "info" },
  APPROVED: { label: "Approved", color: "success" },
  PUBLISHED: { label: "Published", color: "success" },
};

export const RunStatusChip: React.FC<{
  status: RunStatus;
  size?: "small" | "medium";
}> = ({ status, size = "small" }) => {
  const m = RUN_MAP[status];
  return (
    <Chip
      size={size}
      color={m.color}
      icon={m.icon}
      label={m.label}
      variant="outlined"
    />
  );
};

export const AgentStatusChip: React.FC<{
  status: AgentStatus;
  size?: "small" | "medium";
}> = ({ status, size = "small" }) => {
  const m = AGENT_MAP[status];
  return <Chip size={size} color={m.color} label={m.label} variant="filled" />;
};

export const DraftStatusChip: React.FC<{
  status: DraftStatus;
  size?: "small" | "medium";
}> = ({ status, size = "small" }) => {
  const m = DRAFT_MAP[status];
  return <Chip size={size} color={m.color} label={m.label} />;
};
